module.exports = __webpack_public_path__ + "static/img/banner.ce7aca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/ssipc/banner.jpg
// module id = +dFf
// module chunks = 23